export const IMPERSONATION_EXIT_CONFIRMATION = {
  TITLE: 'Disconnect',
  MESSAGE: 'Are you sure you want to disconnect?',
  CONTINUE_LABEL: 'No, continue working',
  DISCONNECT_WITHOUT_SAVING_LABEL: 'Yes, disconnect without saving',
  DISCONNECT_AND_SAVE_LABEL: 'Yes, disconnect and save',
} as const;
